<template>
    <card headerStyle="dark" title="Order Info">
        <p class="mb-1 text-secondary"><i class="fas fa-box mr-2"></i> Placed On {{ moment(order.date).format('M/D/YY h:mm A') }}</p>
        <p v-if="byText" class="mb-0">
            by <inertia-link :href="route('tu.view', order.user.id)">{{ order.user.first_name }} {{ order.user.last_name }}
                <span v-if="!order.user.last_name || order.user.last_name.length == 0">(
                    <Email v-model="order.user.email" />
                    <Phone v-model="order.user.phone_number" />)
                </span>
            </inertia-link>
        </p>
        <p class="mb-0">Order# <span class="text-secondary">{{ order.id }}</span></p>
        <p class="mb-0">Status: <span class="text-secondary">{{ order.status_desc }}</span></p>
        <p class="mb-0" v-if="order.canceled_at">Canceled At <span class="text-secondary">{{
            moment(order.canceled_at).format('M/D/YY h:mm A') }}</span></p>

        <p class="mb-0" v-if="!!order.po_number">PO# <span class="text-secondary">{{ order.po_number }}</span></p>
        <p v-if="order.order_future_date" class="mt-2">
            <DateTimeText v-model="order.order_future_date" prepend="Future Fulfill"
                class="badge badge-info text-white ml-1 p-1"></DateTimeText>
            Cancellation Fee of $50 will be applied if cancelled
        </p>

        <jet-button class="mt-2 mr-2 btn-sm" icon="fas fa-file-invoice-dollar" @click="openPrintReceipt">Print
            Receipt</jet-button>
        <jet-button class="mt-2 btn-sm" icon="fas fa-paper-plane" @click="resendReceipt">Email Receipt</jet-button>

        <jet-button class="mt-2 btn-sm btn-danger float-right" @click="cancelOrder"
            v-if="!order.canceled_at && order.status_desc !== 'Shipped'">Cancel Order</jet-button>
    </card>

    <teleport to="body">
        <PrintModal :printUrl="printUrl" @print="printReceipt" />
    </teleport>
</template>

<script>
import moment from 'moment'
import PrintModal from '@/Components/Modals/PrintModal'

export default {
    data() {
        return {
            printUrl: ''
        }
    },
    props: {
        order: Object,
        is_mtd: {
            type: Boolean,
            default: false
        }
    },
    components: {
        PrintModal
    },
    created() {
        this.moment = moment;
    },
    computed: {
        byText() {
            if (this.is_mtd) return this.$page.props.auth.user.role == 'mtd' && this.order.user.id != this.$page.props.auth.user.id
            else return this.$page.props.auth.user.role == 'mtd'
        }
    },
    methods: {
        openPrintReceipt() {
            this.printUrl = this.route('order.receipt', this.order.id);
            $('#PrintModal').modal('show');
        },
        printReceipt() {
            this.printUrl = this.route('order.receipt', { order: this.order.id, print: 1 });
        },
        resendReceipt() {
            this.$inertia.visit(route(this.is_mtd ? 'mtd.orders.resendreceipt' : 'orders.resendreceipt', this.order))
        },
        cancelOrder() {
            if (this.order.canceled_at || this.order.status_desc === 'Shipped') {
                return
            }
            this.$confirm.require({
                message: 'Are you sure?',
                header: 'Cancel Order',
                icon: null,
                acceptLabel: 'Save',
                rejectLabel: 'Cancel',
                accept: () => {
                    this.$inertia.visit(this.route('mtd.orders.cancel', { order: this.order }))
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });

        }
    }
}
</script>
